import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CognitoService } from '../services/cognito.service';
import { DataService } from '../services/data.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class IsSubscriptionIsExpireddGuard implements CanActivate, CanLoad {
  constructor(private userService: UserService, private cognitoService: CognitoService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean>{
    return new Promise((resolve, reject) => {
      if (this.userService.subscriptionIsExpired()) {
        const getDevice = this.cognitoService.getDevice();
        this.userService.getOpenToken().subscribe(data => {
          if (location.hostname === 'localhost') {
            window.location.href = (`https://localhost:4200/open-id-connect/getToken/${data['openToken']}?redirect=settings&deviceKey=${getDevice['deviceKey']}&deviceGroupKey=${getDevice['deviceGroupKey']}`);
          } else {
            window.location.href = (`${environment.backUrl}/open-id-connect/getToken/${data['openToken']}?redirect=settings&deviceKey=${getDevice['deviceKey']}&deviceGroupKey=${getDevice['deviceGroupKey']}`);
          }
        });
        resolve(false);
      }else{
        resolve(true);
      }
    });
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Promise<boolean> {
      return new Promise((resolve, reject) => {
        if (this.userService.subscriptionIsExpired()) {
          resolve(true);
        }else{
          resolve(true);
        }
      });
  }
}
